module.exports = __webpack_public_path__ + "img/secondSide.188f57c5.svg";